import { render, staticRenderFns } from "./LivestreamComment.vue?vue&type=template&id=34eb25d2&"
import script from "./LivestreamComment.vue?vue&type=script&lang=js&"
export * from "./LivestreamComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports